/**
 * Renders a user avatar that falls back to the StudyMateRanked book logo
 * when the user hasn't uploaded a custom one. Used in headers, leaderboards,
 * profile, lobby/match screens.
 */
export default function UserAvatar({ src, alt = "", size = 36, glow = false, className = "" }) {
  const url = src || "/studymate-logo.png";
  const isDefault = !src;
  return (
    <div
      className={`relative rounded-full overflow-hidden border ${isDefault ? "border-blue-500/40 bg-blue-500/10" : "border-white/15 bg-white/5"} ${className}`}
      style={{ width: size, height: size }}
      data-testid="user-avatar"
      data-avatar-default={isDefault ? "1" : "0"}
    >
      {glow && (
        <div
          aria-hidden
          className="absolute inset-0 rounded-full"
          style={{
            background: "radial-gradient(circle, rgba(59,130,246,0.40), transparent 70%)",
            filter: "blur(6px)",
            zIndex: 0,
          }}
        />
      )}
      <img
        src={url}
        alt={alt}
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ padding: isDefault ? Math.round(size * 0.15) : 0 }}
      />
    </div>
  );
}
